// Mutations and Actions
import {
  createSimpleRequest,
  SimpleRequestOptions,
  OrdsQueryParams,
} from '@/business/apiTreatment/request/reusableBaseRequest';
import BaseModulePlugins from '@/store/baseModule/plugins';
import actions from './actions';
import mutations from './mutations';

interface BaseModuleOptions {
  store: any;
  name: string;
  searchAttributesArray?: string[];
  idField?: string;
  limitItemsRequest?: number;
  useEntities?: boolean;
  makeQueryParams?: (params: SimpleRequestOptions) => OrdsQueryParams;
  serviceAPI: any;
  customGetters?: any;
  customMutations?: any;
  customActions?: any;
  truncateEntities?: number;
}

const createReusableBaseModule = ({
  store,
  name,
  searchAttributesArray = [],
  idField = null,
  limitItemsRequest,
  useEntities,
  truncateEntities,
  makeQueryParams = createSimpleRequest({
    searchAttributesArray,
    limitItemsRequest,
    useEntities,
    truncateEntities,
    idField,
  }),
  serviceAPI,
  customGetters = null,
  customMutations = null,
  customActions = null,
}: BaseModuleOptions) => {
  const names = ['reusable', name];
  if (!store.hasModule(names)) {
    store.registerModule(names, {
      namespaced: true,
      state() {
        return {
          filters: {
            search: '',
          },
          idx: [],
          items: {
            isLoading: false,
            data: [],
            error: null,
            request: null,
          },
        };
      },
      getters: {
        search: (state) => state.filters.search,
        isLoadingItems: (state) => state.items.isLoading,
        requestItems: (state) => state.items.request,
        items: (state) => state.items.data,
        idx: (state) => state.idx,
        ...customGetters,
      },
      mutations: mutations({ customMutations }),
      actions: actions({
        customActions,
        makeQueryParams,
        serviceAPI,
      }),
    });
  }

  if (useEntities) {
    const basePlugin = new BaseModulePlugins({
      module: `reusable/${name}`,
      paramId: null,
      store,
    });
    basePlugin.loadItemsOnCurrentEntityChange();
  }
  return { names, path: `reusable/${name}` };
};

export default createReusableBaseModule;
